var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconContact02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 125,
    viewBox: "0 0 164 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dot",
    clipPath: "url(#clip0_885_31260)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M150.11 13.75H21.4V100.13H150.11V13.75Z",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.4 36.3984L85.76 68.7384L150.11 36.3984",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M123.69 32.3606C126.65 32.3606 129.05 29.9609 129.05 27.0006C129.05 24.0404 126.65 21.6406 123.69 21.6406C120.73 21.6406 118.33 24.0404 118.33 27.0006C118.33 29.9609 120.73 32.3606 123.69 32.3606Z",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.76997 103.251C9.73022 103.251 12.13 100.851 12.13 97.8913C12.13 94.931 9.73022 92.5312 6.76997 92.5312C3.80973 92.5312 1.40997 94.931 1.40997 97.8913C1.40997 100.851 3.80973 103.251 6.76997 103.251Z",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M66.28 124.859C69.02 124.859 69.02 120.609 66.28 120.609C63.54 120.609 63.54 124.859 66.28 124.859Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M41.86 75.5508C44.6 75.5508 44.6 71.3008 41.86 71.3008C39.12 71.3008 39.12 75.5508 41.86 75.5508Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M31.3 113.66C34.04 113.66 34.04 109.41 31.3 109.41C28.56 109.41 28.56 113.66 31.3 113.66Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M8.64002 59.0703C11.38 59.0703 11.38 54.8203 8.64002 54.8203C5.90002 54.8203 5.90002 59.0703 8.64002 59.0703Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M161.77 47.2891C164.51 47.2891 164.51 43.0391 161.77 43.0391C159.03 43.0391 159.03 47.2891 161.77 47.2891Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M97.97 4.25C100.71 4.25 100.71 0 97.97 0C95.23 0 95.23 4.25 97.97 4.25Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_885_31260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 163.82,
    height: 124.86,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContact02);
export default __webpack_public_path__ + "static/media/icon_contact_02.39c186a10ccae8459761fe748c5e1fa6.svg";
export { ForwardRef as ReactComponent };